@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import xyz.malefic.staticsite.components.layouts.NavBarLayout as _xyz_malefic_staticsite_components_layouts_NavBarLayout
import xyz.malefic.staticsite.pages.BeyondGdpPage as _xyz_malefic_staticsite_pages_BeyondGdpPage
import xyz.malefic.staticsite.pages.FreeMoneyPage as _xyz_malefic_staticsite_pages_FreeMoneyPage
import xyz.malefic.staticsite.pages.HomePage as _xyz_malefic_staticsite_pages_HomePage
import xyz.malefic.staticsite.pages.HumanProgressPage as _xyz_malefic_staticsite_pages_HumanProgressPage
import xyz.malefic.staticsite.pages.LeisureTimePage as _xyz_malefic_staticsite_pages_LeisureTimePage
import xyz.malefic.staticsite.pages.OpenBordersPage as _xyz_malefic_staticsite_pages_OpenBordersPage
import xyz.malefic.staticsite.pages.RadicalIdeasPage as _xyz_malefic_staticsite_pages_RadicalIdeasPage
import xyz.malefic.staticsite.pages.UselessJobsPage as _xyz_malefic_staticsite_pages_UselessJobsPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Utopia For Realists"))
    BasePath.set("/UtopiaForRealistsSite/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_staticsite_components_layouts_NavBarLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_HomePage()
        }
        ctx.router.register(
            "/beyond-gdp",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_BeyondGdpPage()
        }
        ctx.router.register(
            "/free-money",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_FreeMoneyPage()
        }
        ctx.router.register(
            "/human-progress",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_HumanProgressPage()
        }
        ctx.router.register(
            "/leisure-time",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_LeisureTimePage()
        }
        ctx.router.register(
            "/open-borders",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_OpenBordersPage()
        }
        ctx.router.register(
            "/radical-ideas",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_RadicalIdeasPage()
        }
        ctx.router.register(
            "/useless-jobs",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_UselessJobsPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.staticsite.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
